<template>  
  <mission-detail-graphics :sciGraph="false" :simuGraph="true" :isleft="isleft" :uiid="uiid" :mission="infosSimMission.mission" :tabState="simulationState" />
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import MissionDetailGraphics from '@/components/mission/MissionDetailGraphics.vue'
import { MapUiState } from '@/models/ui/MapUiState'
import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'

@Component({
  name: 'SimulationDetailSinglePlots',
  props: {
    isleft:Boolean,
    uiid:{
        type: String,
        required: true
    }
  },
  components:{MissionDetailGraphics}
})
export default class SimulationDetailSinglePlots extends Vue {      

  isleft!:boolean
  uiid!:string

  get simUiid()
  {
    return `${this.uiid}_${this.bestFitMisId}`
  }


  get missionGlobal(){
   return this.$store.myGetters.originalAdmMissionGlobal
 }

  get simulation_uiid() {
    return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get simulationState() { 
    //retourne un MapUiState    
    return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState         
  }

  get missionVirtualsById(){
   return this.$store.myGetters.missionVirtualsById
 }

  get infosSimMission() {
    return this.missionVirtualsById[this.bestFitMisId]
  }

  get map_uiid(){
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,'map')
 }

 get mapState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.map_uiid) as MapUiState         
 }

 get bestFitMisId(){
   return this.mapState?.bestFitMisId
 }

  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }  

  }
</script>